module.exports = __webpack_public_path__ + "img/yidong_management.485a74e6.jpg";